import React from "react"

export const VerfahrensabwicklungTimeline = ({ timeline_items }) => {
  return (
    <div className="timeline is-centered-desktop">
      {timeline_items?.map(({ title, content, tag }, index) => {
        return (
          <div className="timeline-item" key={"history-" + index}>
            <div className="timeline-marker is-sonnengelb"></div>
            <div className="timeline-content">
              <div className="is-flex">
                <p className="title is-4 has-text-mitternachtsblau">{title}</p>
                {!!tag ? (
                  <div className="tag is-rounded is-mitternachtsblau-10 has-text-title ml-3">
                    {tag}
                  </div>
                ) : null}
              </div>
              <div
                className="has-text-mitternachtsblau content"
                dangerouslySetInnerHTML={{ __html: content }}
              ></div>
              <div className="mt-4 is-flex" style={{ width: "100%" }}></div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
